
import { computed, defineComponent} from "vue";
import LoginForm from "./UserDataForm.vue";
import LoginPasswordForm from "./LoginPasswordForm.vue";
import { store } from "@/store/LoginDataStore";

export default defineComponent({
  name: "LoginCard",
  components: {
    LoginForm,
    LoginPasswordForm,
  },
  setup() {
    const state = store.getState();

    const view = computed(() => state.view);
    const successMessage = computed(() => state.successMessage);
    const errorMessage = computed(() => state.errorMessage);

    return {
      view,
      successMessage,
      errorMessage,
    };
  },
});
